<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconArrowUp_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="m18.705 10.543-6.13-6.132a.836.836 0 0 0-1.15 0l-6.13 6.132a.813.813 0 0 0 .935 1.302l4.52-2.246v8.651a1.25 1.25 0 0 0 2.5 0V9.599l4.52 2.246a.813.813 0 0 0 .935-1.302"
    />
</svg>
